import { useEffect, useState } from "react";
import { useSocketContext } from "./SocketContext";

export const useSocketChannel = <T>(channel: string): T | null => {
  const { socket } = useSocketContext();
  const [data, setData] = useState<T | null>(null);

  useEffect(() => {
    if (!channel) return;

    const handleData = (message: T) => {
      setData(message);
    };

    // Listen for data on the channel
    socket.on(channel, handleData);

    // Clean up the listener when the component unmounts
    return () => {
      socket.off(channel, handleData);
    };
  }, [socket, channel]);

  return data; // Return the latest data received from the channel
};
